import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function createThreadFailure(draft: Draft<IInterventionData>) {
  draft.createThread.config.isLoading = false;
}

export default createThreadFailure;
